import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@components/button';

import * as Styled from './card.styled';

type OwnProps = {
	title: string;
	link: string;
	image: string;
};

const Card: React.FC<OwnProps> = ({ title, link, image }) => {
	const { t } = useTranslation('main');

	return (
		<Styled.Wrapper>
			<Styled.Title dangerouslySetInnerHTML={{ __html: title }} />
			<Link to={link}>
				<Button hasIcon>{t('go')}</Button>
			</Link>
			<Styled.BgImage src={image} alt='card' />
		</Styled.Wrapper>
	);
};
export default Card;
